import React from 'react';
export const HighlightedText = ({ children }: { children: string }) => {
  return <span className="text-code-c">{children}</span>;
};
